<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="questions.length > 0; else noQuestions">

    <div class="detailed-solutions-wrapper">
      <div class="detailed-solutions-container">
        <!-- Header -->
        <div class="header">
          <div class="logo-title">
            <h1 matTooltip="{{quizName}}">
              <img src="assets/images/student_card_2.svg" alt="previous" class="titlelogo me-1" />
              <span class="truncate">{{ quizName}}</span>
            </h1>
          </div>
          <button class="back-button" (click)="navigateBack()">← Back to Challenges</button>
        </div>

        <!-- Content -->
        <div class="content">
          <h2 style="text-align: left;">Detailed Solutions</h2>

          <div class="question-nav-container">
            <button class="nav-arrow left" (click)="scrollQuestions('left')"
              *ngIf="questions.length >= ScrollQuestionInStudentResult.MAX_DISPLAY"><i
                class="bi bi-chevron-left"></i></button>
            <div class="question-nav" #questionNav>
              <span class="qbox" *ngFor="let question of questions; let i = index"
                [class.correct]="getQuestionStatus(i).isCorrect" [class.incorrect]="getQuestionStatus(i).isIncorrect"
                [class.not-answered]="getQuestionStatus(i).isSkipped" [class.partial]="getQuestionStatus(i).isPartial"
                (click)="scrollToQuestion(i)">
                {{ question.id }}
              </span>
            </div>
            <button class="nav-arrow right" *ngIf="questions.length >= ScrollQuestionInStudentResult.MAX_DISPLAY"
              (click)="scrollQuestions('right')"><i class="bi bi-chevron-right"></i></button>
          </div>

          <!-- Questions Container -->
          <div #questionsContainer class="questions">
            <div class="question-section" *ngFor="let question of questions; let i = index" [id]="'question-' + i"
              [class.highlighted]="selectedQuestionIndex === i">

              <div class="question-text">
                <div class="q-left">
                  <strong>Q{{ question.id }}:</strong>
                  <app-question-blocks [blocks]="question.question_blocks" [content]="question.text" [diagrams]="question.diagrams || []"></app-question-blocks>
                </div>
                <div class="q-right">
                  <span class="tag" *ngIf="!getQuestionStatus(i).isPartial && getAnswerStatus(i)"
                    [class.correct]="getQuestionStatus(i).isCorrect"
                    [class.incorrect]="getQuestionStatus(i).isIncorrect"
                    [class.not-answered]="getQuestionStatus(i).isSkipped">
                    {{ getAnswerStatus(i) }}
                  </span>
                  <span class="partial-badge" *ngIf="getQuestionStatus(i).isPartial">Partially Correct</span>
                 <!-- will be using this diagram in next release
                   <div class="question-diagram-wrapper"
                  *ngIf="question.has_diagram && question.diagram_url">
                    
                  <img [src]="question.diagram_url" alt="Question Diagram"
                  class="question-diagram"/>
                </div> -->
                </div>
              </div>

              <!-- Options for MCQ/True-False -->
              <div class="options" *ngIf="question.questionType !== 'OPEN_ENDED' && question.options.length > 0">
                <label class="custom-radio" *ngFor="let option of question.options"
                  [class.correct-option]="isCorrectOption(i, option)" [class.user-correct]="isUserCorrect(i, option)"
                  [class.user-incorrect]="isUserIncorrect(i, option)">

                  <input type="radio" [checked]="option.text === question.userAnswer" disabled />
                  <span class="radio-check"></span>
                  <span class="option-text">
                    <app-question-blocks [blocks]="option.blocks" [content]="option.text" [diagrams]="[]"></app-question-blocks>
                  </span>

                  <span class="answer-status" *ngIf="isUserAnswer(i, option)"
                    [class.correct]="getQuestionStatus(i).isCorrect"
                    [class.incorrect]="getQuestionStatus(i).isIncorrect"
                    [class.not-answered]="getQuestionStatus(i).isSkipped">
                    Your Answer
                  </span>
                  <span class="answer-status correct" *ngIf="isCorrectAnswer(i, option) && !isUserAnswer(i, option)">
                    Correct Answer
                  </span>
                </label>
              </div>

              <!-- Open Ended Answers -->
              <div class="open-ended-answers" *ngIf="question.questionType === 'OPEN_ENDED'">
                <!-- Your Answer-->
                <div class="answer-box" [class.correct-answer-box]="getQuestionStatus(i).isCorrect"
                  [class.incorrect-answer-box]="getQuestionStatus(i).isIncorrect"
                  [class.not-answered-box]="getQuestionStatus(i).isSkipped">
                  <div class="answer-label">Your Answer:</div>
                  <div class="answer-content">
                    <app-math-latex [content]="getUserAnswerText(i)"></app-math-latex>
                    </div>
                </div>

                <!-- Correct Answer -->
                <div class="answer-box correct-answer-box" *ngIf="!getQuestionStatus(i).isCorrect">
                  <div class="answer-label">Correct Answer:</div>
                  <div class="answer-content">{{ getCorrectAnswerText(i) }}</div>
                </div>
              </div>

              <!-- Explanation -->
              <div class="explanation">
                <strong>Explanation:</strong> 
                <app-math-latex [content]="getExplanation(i)"></app-math-latex>
              </div>

              <!-- Feedback -->
              <div class="feedback">
                <strong>Feedback:</strong> {{ getFeedback(i) }}
              </div>
            </div>

            <!-- Performance Insights -->
            <h6 class="insight d-flex justify-content-start">Performance Insights</h6>
            <div class="performance">
              <div class="strong">
                <h4><img src="assets/images/moving.svg" alt="Submit Icon" height="20" class="me-1" />Strong Areas</h4>
                <div class="tags">
                  <span class="strongspan" *ngFor="let area of strong_areas">{{ area }}</span>
                  <span *ngIf="!strong_areas.length" class="strongspan">None identified</span>
                </div>
              </div>
              <div class="weak">
                <h4><img src="assets/images/target.svg" alt="Submit Icon" height="20" />Areas for Improvement</h4>
                <div class="tags">
                  <span class="weakspan" *ngFor="let area of weakAreas">{{ area }}</span>
                  <span *ngIf="!weakAreas.length" class="weakspan">None identified</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noQuestions>
    <div class="no-questions-message">
      <img src="assets/images/arrow_left_alt.svg" (click)="navigateBack()">
      <p class="text-center">No questions available for this quiz.</p>
    </div>
  </ng-template>
</ng-template>